import { Scrollbars } from "react-custom-scrollbars";
import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import withReducer from 'store/withReducer';
import { useSnackbar } from 'notistack';
import React, { useEffect, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import clsx from 'clsx';
import NotificationCard from './NotificationCard';
import NotificationTemplate from './NotificationTemplate';
import { dismissAll, dismissItem, selectNotifications } from './store/dataSlice';
import reducer from './store';
import { closeNotificationPanel, toggleNotificationPanel } from './store/stateSlice';
import { RootState } from 'store';
import './style.css';

const useStyles = makeStyles({
	root: {
		backgroundColor: '#121212',
		width: 320
	}
});

let displayed: any[] = [];

const storeDisplayed = (id: any) => {
	displayed = [...displayed, id];
};

const locale = {
	MAIN_TITLE: 'Notifications',
	DISMISS_ALL: 'dismiss all',
	NO_ENTRIES_FOUND: 'There are no notifications for now.'
};

function NotificationPanel(props: any) {
	const classes = useStyles();
	const location = useLocation();
	const dispatch = useDispatch();
	const state = useSelector(( state:RootState) => state.notificationPanel.state);
	const notifications = useSelector(selectNotifications);
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();

	useEffect(() => {
		notifications.forEach((item: any) => {
			const { id: key, message, options = {}, dismissed = false } = item;

			if (dismissed) {
				// dismiss snackbar using notistack
				closeSnackbar(key);
				return;
			}
			// do nothing if snackbar is already displayed
			if (displayed.includes(key)) {
				return;
			}


			// display snackbar using notistack
			enqueueSnackbar(message, {
				key,
				...options,
				// autoHideDuration: 3000,
				content: () => (
					<NotificationTemplate
						item={item}
						onClose={() => {
							closeSnackbar(key);
							dispatch(dismissItem(key));
						}}
					/>
				),
				onClose: (event, reason, myKey) => {
					if (options.onClose) {
						options.onClose(event, reason, myKey);
					}
				},
				onExited: (event, myKey) => {}
			});

			// keep track of snackbars that we've displayed
			storeDisplayed(key);
		});
	}, [notifications, closeSnackbar, enqueueSnackbar, dispatch]);

	useEffect(() => {
		if (state) {
			dispatch(closeNotificationPanel());
		}
		// eslint-disable-next-line
	}, [location, dispatch]);

	function handleClose() {
		dispatch(closeNotificationPanel());
	}

	function handleDismiss(id: any) {
		dispatch(dismissItem(id));
	}
	function handleDismissAll() {
		dispatch(dismissAll());
	}

	return (
		<SwipeableDrawer
			classes={{ paper: clsx(classes.root) }}
			open={state}
			anchor="right"
			onOpen={ev => {}}
			onClose={ev => dispatch(toggleNotificationPanel())}
			disableSwipeToOpen
		>
			<IconButton className="m-4 absolute top-0 right-0 z-999" onClick={handleClose}>
				<Icon color="action">close</Icon>
			</IconButton>
			{notifications.length > 0 ? (
				<Scrollbars
					autoHeight
					autoHeightMax={250}
					style={{ overflowX: "hidden", width: "100%," }}
				>
					<div className="flex flex-col">
						<div className="flex justify-between items-end pt-56 mb-36">
							<Typography className="text-28 font-semibold leading-none">{locale.MAIN_TITLE}</Typography>
							<Typography
								className="text-12 underline cursor-pointer"
								color="secondary"
								onClick={handleDismissAll}
							>
								{locale.DISMISS_ALL}
							</Typography>
						</div>
						{notifications.map((item:any) => (
							<NotificationCard key={item.id} className="mb-16" item={item} onClose={handleDismiss} />
						))}
					</div>
				</Scrollbars>
			) : (
				<div className="flex flex-1 items-center justify-center p-16">
					<Typography className="text-24 text-center" color="textSecondary">
						{locale.NO_ENTRIES_FOUND}
					</Typography>
				</div>
			)}
		</SwipeableDrawer>
	);
}

export default withReducer('notificationPanel', reducer)(memo(NotificationPanel));
